export const SIZE_GUIDES = {
  TSHIRT: {
    name: "T-Shirt Size Guide",
    image: "/images/size-guides/tshirt-size-guide.png"
  },
  MENSHIRT: {
    name: "Men-Shirt Size Guide",
    image: "/images/size-guides/men_shirt_size.png"
  },
  PANTS: {
    name: "Pants Size Guide",
    image: "/images/size-guides/pants-size-guide.jpg"
  },
  SHOES: {
    name: "Shoes Size Guide",
    image: "/images/size-guides/shoes-size-guide.jpg"
  },
  HOODIE: {
    name: "Hoodie Size Guide",
    image: "/images/size-guides/hoodie-size-guide.jpg"
  }
}; 